import { Question } from '@/types/exam';
import { RichContent } from '@/components/content/RichContent';
import { DifficultyBadge } from '@/components/ui/DifficultyBadge';

interface QuestionCardProps {
  question: Question;
  questionNumber: number;
  totalQuestions: number;
}

export function QuestionCard({ question, questionNumber, totalQuestions }: QuestionCardProps) {
  return (
    <div className="bg-surface rounded-2xl border border-line p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs sm:text-sm font-medium text-fg-subtle">
          Question {questionNumber}/{totalQuestions}
        </span>
        <div className="flex items-center gap-2">
          <DifficultyBadge difficulty={question.difficulty} size="sm" />
          <span className="text-[10px] sm:text-xs text-fg-faint border border-line px-1.5 py-0.5 rounded">
            {question.points} pt{question.points > 1 ? 's' : ''}
          </span>
        </div>
      </div>

      <RichContent content={question.content} />
    </div>
  );
}
